export const FIFA_PLAYOFF_STAGES = [{
  stage: '1/8 ФИНАЛА',
  matches: [{
    id: 'ClJjw1Og',
    date: '2022-12-03T15:00:00.000Z',
    localTeam: {id: 'WYintcWb', name: 'Нидерланды', score: 3},
    visitorTeam: {id: 'fuitL4CF', name: 'США', score: 1}
  }, {
    id: 'Ya9wwgP2',
    date: '2022-12-03T19:00:00.000Z',
    localTeam: {id: 'f9OppQjp', name: 'Аргентина', score: 2},
    visitorTeam: {id: 'xSrf6qMM', name: 'Австралия', score: 1}
  }, {
    id: 'MVnruykg',
    date: '2022-12-05T15:00:00.000Z',
    localTeam: {id: 'ULXPdOUj', name: 'Япония', score: 1},
    visitorTeam: {id: 'K8aznggo', name: 'Хорватия', score: 2}
  }, {
    id: 'A7cQ5yBg',
    date: '2022-12-05T19:00:00.000Z',
    localTeam: {id: 'I9l9aqLq', name: 'Бразилия', score: 4},
    visitorTeam: {id: 'K6Gs7P6G', name: 'Южная Корея', score: 1}
  }, {
    id: 'bswGq3oQ',
    date: '2022-12-04T19:00:00.000Z',
    localTeam: {id: 'j9N9ZNFA', name: 'Англия', score: 3},
    visitorTeam: {id: 'hOIsJLJr', name: 'Сенегал', score: 0}
  }, {
    id: 'Cj8sxDv9',
    date: '2022-12-04T15:00:00.000Z',
    localTeam: {id: 'QkGeVG1n', name: 'Франция', score: 3},
    visitorTeam: {id: '2HzmcynI', name: 'Польша', score: 1}
  }, {
    id: '4fxmve4a',
    date: '2022-12-06T15:00:00.000Z',
    localTeam: {id: 'IDKYO3R8', name: 'Марокко', score: 1},
    visitorTeam: {id: 'bLyo6mco', name: 'Испания', score: 0}
  }, {
    id: 'GpbM6Hem',
    date: '2022-12-06T19:00:00.000Z',
    localTeam: {id: 'WvJrjFVN', name: 'Португалия', score: 6},
    visitorTeam: {id: 'rHJ2vy1B', name: 'Швейцария', score: 1}
  }]
}, {
  stage: '1/4 ФИНАЛА',
  matches: [{
    id: 'G0rn6WE5',
    date: '2022-12-09T19:00:00.000Z',
    localTeam: {id: 'WYintcWb', name: 'Нидерланды', score: 2},
    visitorTeam: {id: 'f9OppQjp', name: 'Аргентина', score: 3}
  }, {
    id: 'lGiFEPmp',
    date: '2022-12-09T15:00:00.000Z',
    localTeam: {id: 'K8aznggo', name: 'Хорватия', score: 2},
    visitorTeam: {id: 'I9l9aqLq', name: 'Бразилия', score: 1}
  }, {
    id: '2g49AZK4',
    date: '2022-12-10T19:00:00.000Z',
    localTeam: {id: 'j9N9ZNFA', name: 'Англия', score: 1},
    visitorTeam: {id: 'QkGeVG1n', name: 'Франция', score: 2}
  }, {
    id: 'hdEvqxcM',
    date: '2022-12-10T15:00:00.000Z',
    localTeam: {id: 'IDKYO3R8', name: 'Марокко', score: 1},
    visitorTeam: {id: 'WvJrjFVN', name: 'Португалия', score: 0}
  }]
}, {
  stage: 'ПОЛУФИНАЛ',
  matches: [{
    id: 'QXChy9gE',
    date: '2022-12-13T19:00:00.000Z',
    localTeam: {id: 'f9OppQjp', name: 'Аргентина', score: 3},
    visitorTeam: {id: 'K8aznggo', name: 'Хорватия', score: 0}
  }, {
    id: 'M9g47WCj',
    date: '2022-12-14T19:00:00.000Z',
    localTeam: {id: 'QkGeVG1n', name: 'Франция', score: 2},
    visitorTeam: {id: 'IDKYO3R8', name: 'Марокко', score: 0}
  }]
}, {
  stage: 'ТРЕТЬЕ МЕСТО',
  matches: [{
    id: 'U7jo7z91',
    date: '2022-12-17T15:00:00.000Z',
    localTeam: {id: 'K8aznggo', name: 'Хорватия', score: 2},
    visitorTeam: {id: 'IDKYO3R8', name: 'Марокко', score: 1}
  }]
}, {
  stage: 'ФИНАЛ',
  matches: [{
    id: 'rBfk6fO7',
    date: '2022-12-18T15:00:00.000Z',
    localTeam: {id: 'f9OppQjp', name: 'Аргентина', score: 4},
    visitorTeam: {id: 'QkGeVG1n', name: 'Франция', score: 3}
  }]
}];
